export const iconFontAwesomeTransportationTruckPickup = (
	<i className="fa-solid fa-truck-pickup"></i>
);
